import { DHLDownStatusResponseRaw } from "./useDHLDownStatus.types";

export const transformDHLDownStatusResponse = (
  responseData: DHLDownStatusResponseRaw
): boolean => Boolean(responseData?.dhl_not_working);
